export enum BodyUnitSystem {
  Metric = 1,
  Imperial = 2,
}
